<template>
	<div class='footer'>
		<div class='textWrapper'>
			<span>{{footer1}}</span>
			<br/>
			<span>{{footer2}}</span>			
			<br/>
			<span>{{footer3}}</span>			
		</div>
	</div>
</template>

<script type='text/ecmascript-6'>
	import {getFooterData} from 'api/footer'
	import {mapGetters} from 'vuex'
	
	export default{
		data() {
			return {
				footer1:'',
				footer2:'',
				footer3:''
			}
		},
		mounted() {
			setTimeout(()=>{
				this._getFooterData()
			},20)			
		},
		computed:{
			...mapGetters([
				'lang'
			])
		},
		methods:{
			_getFooterData() {
				getFooterData(this.lang).then((res)=>{
					this.footer1 = res[0].comp_wish
					this.footer2 = res[0].copyrightInfo
					this.footer3 = res[0].name_upper
				})
			}
		},
		watch:{
			lang() {
				this._getFooterData()
			}
		}
	}
</script>

<style lang='stylus' scoped rel='stylesheel/stylus'>
@import '~common/stylus/variable'

.footer
	width:100%
	min-width:$minWidth
	background-color:$cb-footer
	text-align:center
	padding-top:50px
	.textWrapper
		width:90%
		margin:0 auto
		padding:20px 0
		line-height:25px
		font-size:$fs-medium
		color:rgba(255,255,255,0.3)
		border-top:1px solid rgba(255,255,255,0.1)
</style>


// WEBPACK FOOTER //
// src/base/footer/footer.vue